import { ClickAwayListener, Fade, Paper, Popper } from "@mui/material";
import { IPopperWrapper } from "Common/Interfaces/Components/Wrappers/IPopperWrapper";

export const PopperWrapper: React.FC<IPopperWrapper> = (props) => {
  const { open, anchorEl, onClose, children, paperProps, popperProps, placement, zIndex } = props;
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={placement ?? "bottom-start"}
      transition
      disablePortal={false}
      role={undefined}
      style={{ zIndex: zIndex ?? 1205 }}
      {...popperProps}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Paper
            variant="menu"
            sx={{
              overflow: "auto",
           
            }}
            {...paperProps}
          >
            <ClickAwayListener onClickAway={onClose}>{children}</ClickAwayListener>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};
